// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var StoreWithAuth = require("../../../shared/src/StoreWithAuth.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Selectors = require("./WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");

function getAuthorizedClientForIO(dispatch) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Selectors.getAuthorizedClient, (function (param) {
                                return Relude_IO.fromOption(Relude_Globals.id, param);
                              }), param);
                }), (function (param) {
                  return Relude_IO.catchError((function (param) {
                                return Relude_IO.flatMap((function (param) {
                                              return Relude_IO.$$throw(/* Unauthorized */0);
                                            }), Curry._1(dispatch, WebStore_Types_Action.logout));
                              }), param);
                }), param);
  };
}

function getUnauthorizedClientForIO(param) {
  return Relude_Globals.$great$great(WebStore_Selectors.getApolloClient, Relude_IO.pure, param);
}

var include = StoreWithAuth.MakeThunkHelpers({
      getUnauthorizedClientForIO: getUnauthorizedClientForIO,
      getAuthorizedClientForIO: getAuthorizedClientForIO
    });

var getAuthorizedClientForIO$1 = include.getAuthorizedClientForIO;

var getUnauthorizedClientForIO$1 = include.getUnauthorizedClientForIO;

var getClientForAuthType = include.getClientForAuthType;

var continuation = include.continuation;

var updateState = include.updateState;

var sideEffect = include.sideEffect;

var getAsyncResult = include.getAsyncResult;

var updateAsyncResult = include.updateAsyncResult;

var loadAsyncData = include.loadAsyncData;

var runAsyncMutation = include.runAsyncMutation;

var makeSubscriptionResponseHandler = include.makeSubscriptionResponseHandler;

var Lens = include.Lens;

exports.getAuthorizedClientForIO = getAuthorizedClientForIO$1;
exports.getUnauthorizedClientForIO = getUnauthorizedClientForIO$1;
exports.getClientForAuthType = getClientForAuthType;
exports.continuation = continuation;
exports.updateState = updateState;
exports.sideEffect = sideEffect;
exports.getAsyncResult = getAsyncResult;
exports.updateAsyncResult = updateAsyncResult;
exports.loadAsyncData = loadAsyncData;
exports.runAsyncMutation = runAsyncMutation;
exports.makeSubscriptionResponseHandler = makeSubscriptionResponseHandler;
exports.Lens = Lens;
/* include Not a pure module */
